import { Observable } from 'rxjs';
import { RentalPolicyResponse } from '../models/rental-policy-response.model';

export abstract class RentalPolicyRepository {
    abstract getRentalPolicy(): Observable<RentalPolicyResponse>;
}
